module.exports = __webpack_public_path__ + "static/img/1.f62d06cd.jpg";